import React, { useState, useEffect, useRef, useContext } from "react";
import AuthContext from "../../context/Services/Auth";

import { useNavigate } from "react-router-dom";
import "./Shipments.css";

import DropDown from "../../Components/DropDown/DropDown";
import Modal from "../../Components/Modal/Modal";
import Input from "../../Components/Input/Input";
import Message from "../../Components/Message/Message";
import ViewStockModal from "../../Components/ViewStockModal/ViewStockModal";
import SearchableSelect from "../../Components/SearchableSelect/SearchableSelect";
import { generateBLPdf } from "../../Components/BLPrintView/BLPrintView";
import swal from "sweetalert";
import { Parser } from "html-to-react";
import QRCode from "react-qr-code";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import GlobalContext from "../../context/GlobalContext";

import { MdDeleteOutline } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { FaEye, FaPlus, FaMinus, FaTrash, FaUser } from "react-icons/fa";
import { IoMdArrowDropdown } from "react-icons/io";
import { MdDateRange } from "react-icons/md";
import { IoIosArrowUp, IoIosArrowDown, IoIosAdd } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { GrStatusInfo } from "react-icons/gr";
import { RiArrowUpSLine, RiArrowDownSLine } from "react-icons/ri";
import { IoDocumentTextOutline } from "react-icons/io5";
import { HiQrcode } from "react-icons/hi";
import { AiOutlinePrinter } from "react-icons/ai";
import { IoReceiptOutline } from "react-icons/io5";
import { PiWarningCircleFill } from "react-icons/pi";
import { BiUndo } from "react-icons/bi";

// Import Livraison service for deliveries
import {
  get_all_livraisons,
  get_livraison,
  create_livraison,
  update_livraison,
  delete_livraison,
  bulk_update_status,
  get_all_statuses,
} from "../../context/Services/Livraison";

import { get_all_stock } from "../../context/Services/Stock";
import { search_clients } from "../../context/Services/Clients";
import { get_all_mode_reglements } from "../../context/Services/Settings";
import { get_all_staff } from "../../context/Services/Staff";
import { formatDate, containsQuery } from "../../utils/Helper";

const Shipments = () => {
  const { store } = useContext(GlobalContext);
  const { userData } = useContext(AuthContext);

  const { t } = useTranslation();
  const htmlParser = new Parser();

  const qrRef = useRef();

  const navigate = useNavigate();

  // Statuses from API
  const [statuses, setStatuses] = useState([]);

  // Mode de règlement from API
  const [modeReglements, setModeReglements] = useState([]);

  // Commercial users for filter
  const [commercialUsers, setCommercialUsers] = useState([]);

  // Stock items for dropdown
  const [stockItems, setStockItems] = useState([]);

  const [selectedMonth, setSelectedMonth] = useState({
    date: new Date(),
    monthNum: new Date().getMonth() + 1,
  });

  // Empty item template for multi-product
  const emptyItem = {
    stock_id: "",
    quantity: "",
    unit_price: "",
    is_return: false,
  };

  // Form payload for add/edit - now with items array
  const initialPayload = {
    _id: null,
    adresse: "",
    buyer: "",
    buyer_phone: "",
    note: "",
    status: "",
    remise: 0,
    items: [{ ...emptyItem }],
    reglements: [{ mode_reglement: "", amount: "" }],
  };
  const [payload, setPayload] = useState(initialPayload);
  const [isEditMode, setIsEditMode] = useState(false);

  const initial_search_payload = {
    query: "",
    order_by: "new",
    employee_id: "",
  };
  const [searchPayload, setSearchPayload] = useState(initial_search_payload);

  const [showFullTable, setShowFullTable] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [livraisons, setLivraisons] = useState({ livraisons: [], total: 0 });

  const [showStatusUpdate, setShowStatusUpdate] = useState(false);
  const [showStock, setShowStock] = useState({
    status: false,
    stock_id: null,
  });

  const [loading, setLoading] = useState(false);
  const [bulkIds, setBulkIds] = useState([]);

  // Client autocomplete state
  const [clientSuggestions, setClientSuggestions] = useState([]);
  const [showClientSuggestions, setShowClientSuggestions] = useState(false);
  const clientSearchTimeout = useRef(null);

  // Print Preview state
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const [previewBlobUrl, setPreviewBlobUrl] = useState(null);
  const [previewMode, setPreviewMode] = useState("a4");
  const [currentLivraison, setCurrentLivraison] = useState(null);

  // Calculate totals from items (with global remise applied)
  const calculateTotals = (items, globalRemise = 0) => {
    let total_amount = 0;
    let total_returns = 0;

    items.forEach(item => {
      const unitPrice = parseFloat(item.unit_price) || 0;
      const quantity = parseInt(item.quantity) || 0;
      const lineTotal = unitPrice * quantity;

      if (item.is_return) {
        total_returns += lineTotal;
      } else {
        total_amount += lineTotal;
      }
    });

    const remisePercent = parseFloat(globalRemise) || 0;
    const total_remise = total_amount * (remisePercent / 100);

    return {
      total_amount,
      total_returns,
      total_remise,
      net_amount: total_amount - total_remise - total_returns
    };
  };

  const handle_add_bulk = (id) => {
    if (bulkIds.includes(id)) {
      const filter_out = bulkIds.filter((elem) => elem !== id);
      setBulkIds(filter_out);
    } else {
      setBulkIds((prev) => [...prev, id]);
    }
  };

  const handle_navigate_stock = (id, action) => {
    window.open(`/stock/${id}?action=${action}`);
  };

  // Fetch all deliveries
  const handle_get_livraisons = async () => {
    try {
      const res = await get_all_livraisons(searchPayload, selectedMonth?.monthNum);
      setLivraisons(res?.data || { livraisons: [], total: 0 });
    } catch (e) {
      console.log(e);
    }
  };

  // Fetch statuses from API
  const handle_get_statuses = async () => {
    try {
      const res = await get_all_statuses();
      setStatuses(res?.data || []);
    } catch (e) {
      console.log(e);
    }
  };

  // Fetch mode de règlement from API
  const handle_get_mode_reglements = async () => {
    try {
      const res = await get_all_mode_reglements();
      setModeReglements(res?.data || []);
    } catch (e) {
      console.log(e);
    }
  };

  // Fetch stock items for dropdown
  const handle_get_stock = async () => {
    try {
      const res = await get_all_stock({ query: "" });
      // Backend returns { data: { stock: [...], total_stock_mad: ... } }
      const stockData = res?.data?.stock || res?.stock || [];
      setStockItems(stockData);
    } catch (e) {
      console.log(e);
      setStockItems([]);
    }
  };

  // Fetch commercial users for filter (admin only)
  const handle_get_commercial_users = async () => {
    if (userData?.role === "commercial") return; // Commercial users don't need this
    try {
      const res = await get_all_staff();
      // Filter to only show commercial users
      const commercials = (res?.data || []).filter(u => u.role === "commercial");
      setCommercialUsers(commercials);
    } catch (e) {
      console.log(e);
      setCommercialUsers([]);
    }
  };

  // Delete a delivery
  const handle_delete_livraison = async (id) => {
    const willDelete = await swal({
      title: "Es-vous sûr ?",
      text: t("Est ce que vous voulez vraiment supprimer ?"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      try {
        await delete_livraison(id);
        handle_get_livraisons();
      } catch (e) {
        console.log(e);
      }
    }
  };

  // Bulk update status
  const handle_bulk_update_status = async () => {
    if (!payload.status) {
      swal("Error", t("Veuillez sélectionner un statut"), "error");
      return;
    }

    setLoading(true);
    try {
      await bulk_update_status(bulkIds, payload.status);
      handle_get_livraisons();
      setBulkIds([]);
      setPayload(initialPayload);
      setShowStatusUpdate(false);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  // Open edit modal with data - now handles multi-item structure
  const handle_open_edit = async (item) => {
    try {
      const res = await get_livraison(item?._id);
      const data = res?.data;

      // Convert to payload format
      let items = [];
      if (data?.items && data.items.length > 0) {
        items = data.items.map(item => ({
          stock_id: item.stock_id?._id || item.stock_id || "",
          quantity: item.quantity || 1,
          unit_price: item.unit_price || "",
          is_return: item.is_return || false,
        }));
      } else if (data?.stock_id) {
        // Legacy single-product format
        items = [{
          stock_id: data.stock_id?._id || data.stock_id || "",
          quantity: data.quantity_declared || 1,
          unit_price: data.sell_price || "",
          is_return: false,
        }];
      }

      setPayload({
        _id: data?._id,
        adresse: data?.adresse || "",
        buyer: data?.buyer || "",
        buyer_phone: data?.buyer_phone || "",
        note: data?.note || "",
        status: data?.status?._id || "",
        remise: data?.remise || 0,
        items: items.length > 0 ? items : [{ ...emptyItem }],
        reglements: data?.reglements?.length > 0
          ? data.reglements.map(r => ({
            mode_reglement: r.mode_reglement?._id || r.mode_reglement || "",
            amount: r.amount || ""
          }))
          : [{ mode_reglement: "", amount: "" }],
      });
      setIsEditMode(true);
      setShowAddModal(true);
    } catch (e) {
      console.log(e);
    }
  };

  // Handle item changes
  const handleItemChange = (index, field, value) => {
    setPayload(prev => {
      const newItems = [...prev.items];
      let updatedItem = { ...newItems[index], [field]: value };

      if (field === 'stock_id' && value) {
        const selectedProduct = stockItems.find(s => s._id === value);
        if (selectedProduct) {
          updatedItem.unit_price = selectedProduct.prix_de_vente || selectedProduct.sell_price || "";
        }
      }

      newItems[index] = updatedItem;
      return { ...prev, items: newItems };
    });
  };

  // Add new item row
  const addItem = () => {
    setPayload(prev => ({
      ...prev,
      items: [...prev.items, { ...emptyItem }]
    }));
  };

  // Remove item row
  const removeItem = (index) => {
    if (payload.items.length <= 1) return;
    setPayload(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };

  // Toggle return status for item
  const toggleReturn = (index) => {
    handleItemChange(index, 'is_return', !payload.items[index].is_return);
  };

  // Handle form submission (create or update)
  const handle_submit = async () => {
    // Validate required fields
    if (!payload.buyer) {
      swal("Error", t("Veuillez entrer le nom du destinataire"), "error");
      return;
    }

    // Validate items
    const validItems = payload.items.filter(item => item.stock_id && item.unit_price !== undefined);
    if (validItems.length === 0) {
      swal("Error", t("Veuillez ajouter au moins un produit"), "error");
      return;
    }

    setLoading(true);
    try {
      // Capture browser geolocation (non-blocking)
      let coordinates = null;
      try {
        if (navigator.geolocation) {
          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
              enableHighAccuracy: false,
              timeout: 5000,
              maximumAge: 60000,
            });
          });
          coordinates = [position.coords.latitude, position.coords.longitude];
        }
      } catch (geoError) {
        console.log("Geolocation unavailable:", geoError.message);
      }

      // Auto-set status to first status or use existing status if editing
      const statusToUse = payload.status || statuses[0]?._id;

      // Filter valid reglements (must have both mode and amount)
      const validReglements = (payload.reglements || []).filter(
        r => r.mode_reglement && r.amount
      );

      const submitData = {
        ...payload,
        coordinates,
        status: statusToUse,
        remise: parseFloat(payload.remise) || 0,
        items: validItems.map(item => ({
          ...item,
          unit_price: item.unit_price === "" ? 0 : item.unit_price,
          quantity: parseInt(item.quantity) || 0
        })),
        reglements: validReglements
      };

      if (isEditMode && payload._id) {
        // Update existing
        await update_livraison(payload._id, submitData);
      } else {
        // Create new
        await create_livraison(submitData);
      }

      handle_get_livraisons();
      setPayload(initialPayload);
      setIsEditMode(false);
      setShowAddModal(false);
    } catch (e) {
      console.log(e);
      const message = e?.response?.data?.message || "Error";
      if (message === "PRICE_BELOW_MINIMUM" || message === "PRICE_BELOW_BASE_PRICE") {
        swal("Error", t("Le prix est inférieur au prix de vente minimum autorisé"), "error");
      } else if (message === "PRODUCT_NOT_ASSIGNED") {
        swal("Error", t("Vous n'êtes pas autorisé à vendre ce produit"), "error");
      } else if (message === "AMOUNT_EXCEEDED") {
        swal("Error", t("Quota dépassé pour ce produit"), "error");
      } else if (message === "INSUFFICIENT_STOCK") {
        swal("Error", t("Stock insuffisant"), "error");
      } else {
        swal("Error", message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  // Open add modal (reset form)
  const handle_open_add = () => {
    setPayload({
      ...initialPayload,
      status: statuses[0]?._id || "",
      items: [{ ...emptyItem }],
      reglements: [{ mode_reglement: "", amount: "" }]
    });
    setIsEditMode(false);
    setShowAddModal(true);
    setClientSuggestions([]);
    setShowClientSuggestions(false);
  };

  // Handle buyer input change with debounced client search
  const handleBuyerChange = (value) => {
    setPayload((prev) => ({ ...prev, buyer: value }));

    // Clear any existing timeout
    if (clientSearchTimeout.current) {
      clearTimeout(clientSearchTimeout.current);
    }

    // Debounce client search
    if (value && value.length >= 2) {
      clientSearchTimeout.current = setTimeout(async () => {
        try {
          const res = await search_clients(value);
          setClientSuggestions(res?.data || []);
          setShowClientSuggestions(res?.data?.length > 0);
        } catch (e) {
          console.log(e);
          setClientSuggestions([]);
        }
      }, 300);
    } else {
      setClientSuggestions([]);
      setShowClientSuggestions(false);
    }
  };

  // Handle client selection from autocomplete
  const handleClientSelect = (client) => {
    setPayload((prev) => ({
      ...prev,
      buyer: client.name,
      buyer_phone: client.phone || prev.buyer_phone,
      adresse: client.address || prev.adresse,
    }));
    setShowClientSuggestions(false);
    setClientSuggestions([]);
  };

  const generateAndDownload = (id) => {
    const tempContainer = document.createElement("div");
    tempContainer.style.position = "absolute";
    tempContainer.style.left = "-9999px";
    document.body.appendChild(tempContainer);

    const tempQRCode = (
      <div ref={qrRef}>
        <QRCode value={`livraison_${id}`} />
      </div>
    );

    import("react-dom").then((ReactDOM) => {
      ReactDOM.render(tempQRCode, tempContainer, () => {
        const svg = tempContainer.querySelector("svg");
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const img = new Image();
        const svgBlob = new Blob([svgData], {
          type: "image/svg+xml;charset=utf-8",
        });
        const url = URL.createObjectURL(svgBlob);

        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          URL.revokeObjectURL(url);

          const pngUrl = canvas.toDataURL("image/png");
          const downloadLink = document.createElement("a");
          downloadLink.href = pngUrl;
          downloadLink.download = `qr-${id}.png`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          document.body.removeChild(tempContainer);
        };

        img.src = url;
      });
    });
  };

  // Download BL as PDF (now generates preview)
  const handleDownloadPdf = async (livraison, mode) => {
    setLoading(true);
    try {
      const blob = await generateBLPdf(livraison, mode, modeReglements, true);
      const url = URL.createObjectURL(blob);
      setPreviewBlobUrl(url);
      setPreviewMode(mode);
      setCurrentLivraison(livraison);
      setShowPrintPreview(true);
    } catch (e) {
      console.error("Preview generation error:", e);
      swal("Error", t("Erreur lors de la génération de l'aperçu"), "error");
    } finally {
      setLoading(false);
    }
  };

  const triggerPreviewDownload = () => {
    if (!previewBlobUrl || !currentLivraison) return;
    const link = document.createElement("a");
    link.href = previewBlobUrl;
    const reference = currentLivraison.reference || currentLivraison._id?.slice(-8) || "BL";
    link.download = `BL-${reference}-${previewMode === "receipt" ? "ticket" : "A4"}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Get display amount for a livraison (handles both old and new format)
  const getDisplayAmount = (elem) => {
    if (elem?.net_amount !== undefined) {
      return elem.net_amount;
    }
    return elem?.sell_price || 0;
  };

  // Get product display for a livraison
  const getProductDisplay = (elem) => {
    if (elem?.items && elem.items.length > 0) {
      if (elem.items.length === 1) {
        return elem.items[0]?.stock_id?.product_name || "-";
      }
      return `${elem.items.length} ${t("produits")}`;
    }
    return elem?.stock_id?.product_name || "-";
  };

  // Resolve the mode label for a reglement (handles populated object or raw id)
  const getReglementModeName = (reg) =>
    reg?.mode_reglement?.value ||
    modeReglements.find(
      (m) => m._id === (reg?.mode_reglement?._id || reg?.mode_reglement)
    )?.value ||
    t("Règlement");

  useEffect(() => {
    handle_get_statuses();
    handle_get_stock();
    handle_get_mode_reglements();
    handle_get_commercial_users();
  }, []);

  useEffect(() => {
    handle_get_livraisons();
  }, [searchPayload.query, searchPayload.order_by, searchPayload.employee_id, selectedMonth, store]);

  const totals = calculateTotals(payload.items, payload.remise);

  return (
    <>
      <Message loading={loading} status={{ status: loading }} />

      <ViewStockModal
        show={showStock?.status}
        setShow={(status) =>
          setShowStock((prev) => ({ ...prev, status: status }))
        }
        stock_id={showStock?.stock_id}
      />


      {/* Add/Edit Delivery Modal — Redesigned */}
      <Modal
        showBakcDrop={showAddModal}
        modal={showAddModal}
        hideModal={() => {
          setShowAddModal(false);
          setPayload(initialPayload);
          setIsEditMode(false);
        }}
        className="bl_custom_modal"
      >
        {/* ── Modal Body (scrollable) ── */}
        <div className="bl_modal_body">

          {/* Header */}
          <div className="bl_modal_header">
            <div className="bl_header_icon">
              <IoDocumentTextOutline />
            </div>
            <h4>
              {isEditMode ? t("Modifier Bon de Livraison") : t("Nouveau Bon de Livraison")}
            </h4>
          </div>

          {/* ─── Section 1: Client ─── */}
          <div className="bl_section">
            <div className="bl_section_header">
              <div className="bl_section_title">
                <div className="bl_sec_icon client"><FaUser size={13} /></div>
                <h5>{t("Informations Client")}</h5>
              </div>
            </div>
            <div className="bl_section_card">
              <div className="bl_customer_grid">
                {/* Destinataire */}
                <div className="bl_field_group" style={{ position: "relative", zIndex: 97 }}>
                  <label className="bl_field_label">{t("Destinataire")} <span className="required">*</span></label>
                  <input
                    className="bl_compact_input"
                    type="text"
                    placeholder={t("Nom du destinataire")}
                    onChange={(e) => handleBuyerChange(e.target.value)}
                    value={payload.buyer}
                    onFocus={() => clientSuggestions.length > 0 && setShowClientSuggestions(true)}
                    onBlur={() => setTimeout(() => setShowClientSuggestions(false), 200)}
                  />
                  {showClientSuggestions && clientSuggestions.length > 0 && (
                    <div className="client_autocomplete_dropdown">
                      {clientSuggestions.map((client) => (
                        <div
                          key={client._id}
                          className="client_autocomplete_item"
                          onMouseDown={() => handleClientSelect(client)}
                        >
                          <span className="client_name">{client.name}</span>
                          {client.phone && <span className="client_phone">{client.phone}</span>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Téléphone */}
                <div className="bl_field_group">
                  <label className="bl_field_label">{t("Telephone")}</label>
                  <input
                    className="bl_compact_input"
                    type="text"
                    placeholder={t("Numéro de téléphone")}
                    onChange={(e) => setPayload((prev) => ({ ...prev, buyer_phone: e.target.value }))}
                    value={payload.buyer_phone}
                  />
                </div>

                {/* Adresse */}
                <div className="bl_field_group">
                  <label className="bl_field_label">{t("Adresse")}</label>
                  <input
                    className="bl_compact_input"
                    type="text"
                    placeholder={t("Adresse de livraison")}
                    onChange={(e) => setPayload((prev) => ({ ...prev, adresse: e.target.value }))}
                    value={payload.adresse}
                  />
                </div>

                {/* Note */}
                <div className="bl_field_group">
                  <label className="bl_field_label">{t("Note")}</label>
                  <input
                    className="bl_compact_input"
                    type="text"
                    placeholder={t("Note optionnelle")}
                    onChange={(e) => setPayload((prev) => ({ ...prev, note: e.target.value }))}
                    value={payload.note}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ─── Section 2: Produits ─── */}
          <div className="bl_section">
            <div className="bl_section_header">
              <div className="bl_section_title">
                <div className="bl_sec_icon product">📦</div>
                <h5>{t("Produits")}</h5>
              </div>
              <button type="button" className="bl_add_link" onClick={addItem}>
                <IoIosAdd size={16} /> {t("Ajouter produit")}
              </button>
            </div>
            <div className="bl_section_card">
              <div className="bl_table_scroll_wrap">
                <table className="bl_items_table">
                  <thead>
                    <tr>
                      <th style={{ width: "40%" }}>{t("Produit")}</th>
                      <th style={{ width: "70px" }}>{t("Qté")}</th>
                      <th style={{ width: "90px" }}>{t("Prix")}</th>
                      <th style={{ width: "100px" }}>{t("Type")}</th>
                      <th style={{ width: "60px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {payload.items.map((item, index) => (
                      <tr key={index} className={item.is_return ? "return_row" : ""}>
                        {/* Product */}
                        <td>
                          <SearchableSelect
                            triggerClassName="bl_compact_select"
                            value={item.stock_id}
                            onChange={(val) => handleItemChange(index, 'stock_id', val)}
                            placeholder={t("Sélectionner...")}
                            options={stockItems.map((stock) => ({
                              value: stock._id,
                              label: `${stock.product_name} (${stock.quantity} ${t("dispo")})`,
                            }))}
                          />
                        </td>
                        {/* Qty */}
                        <td>
                          <input
                            className="bl_compact_input"
                            type="number"
                            value={item.quantity}
                            onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                            min="1"
                            placeholder="0"
                          />
                        </td>
                        {/* Price */}
                        <td>
                          <input
                            className="bl_compact_input"
                            type="number"
                            value={item.unit_price}
                            onChange={(e) => handleItemChange(index, 'unit_price', e.target.value)}
                            placeholder="0.00"
                          />
                        </td>
                        {/* Status toggle pill */}
                        <td>
                          <button
                            type="button"
                            className={`bl_status_pill ${item.is_return ? 'retour' : 'livraison'}`}
                            onClick={() => toggleReturn(index)}
                            title={item.is_return ? t("Cliquez pour marquer comme livraison") : t("Cliquez pour marquer comme retour")}
                          >
                            {item.is_return ? <BiUndo size={12} /> : null}
                            {item.is_return ? t("Retour") : t("Livraison")}
                          </button>
                        </td>
                        {/* Delete */}
                        <td>
                          <button
                            type="button"
                            className="bl_icon_btn danger"
                            onClick={() => removeItem(index)}
                            disabled={payload.items.length <= 1}
                          >
                            <FaTrash size={11} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Add product row (subtle) */}
              <div className="bl_add_product_row">
                <button type="button" className="bl_add_link" onClick={addItem}>
                  <IoIosAdd size={15} /> {t("Ajouter une ligne")}
                </button>
              </div>
            </div>
          </div>

          {/* ─── Section 3: Paiement (Règlements + Remise merged) ─── */}
          <div className="bl_section">
            <div className="bl_section_header">
              <div className="bl_section_title">
                <div className="bl_sec_icon payment">💳</div>
                <h5>{t("Paiement")}</h5>
              </div>
            </div>
            <div className="bl_section_card">
              <div className="bl_payment_grid">

                {/* Règlements */}
                <div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                    <span className="bl_payment_subsection_label">{t("Règlements")}</span>
                    <button
                      type="button"
                      className="bl_add_link"
                      onClick={() => setPayload(prev => ({
                        ...prev,
                        reglements: [...(prev.reglements || []), { mode_reglement: "", amount: "" }]
                      }))}
                    >
                      <IoIosAdd size={15} /> {t("Ajouter")}
                    </button>
                  </div>
                  {(payload.reglements || []).map((reg, index) => (
                    <div key={index} className="bl_reglement_row" style={{ marginBottom: index < (payload.reglements || []).length - 1 ? "6px" : 0 }}>
                      <select
                        className="bl_compact_select"
                        value={reg.mode_reglement}
                        onChange={(e) => {
                          const newRegs = [...(payload.reglements || [])];
                          newRegs[index] = { ...newRegs[index], mode_reglement: e.target.value };
                          setPayload(prev => ({ ...prev, reglements: newRegs }));
                        }}
                      >
                        <option value="">{t("Mode de règlement...")}</option>
                        {modeReglements.map((mode) => (
                          <option key={mode._id} value={mode._id}>{mode.value}</option>
                        ))}
                      </select>
                      <input
                        className="bl_compact_input"
                        type="number"
                        value={reg.amount}
                        onChange={(e) => {
                          const newRegs = [...(payload.reglements || [])];
                          newRegs[index] = { ...newRegs[index], amount: e.target.value };
                          setPayload(prev => ({ ...prev, reglements: newRegs }));
                        }}
                        placeholder={t("Montant")}
                      />
                      <button
                        type="button"
                        className="bl_icon_btn danger"
                        onClick={() => {
                          if ((payload.reglements || []).length <= 1) return;
                          setPayload(prev => ({
                            ...prev,
                            reglements: prev.reglements.filter((_, i) => i !== index)
                          }));
                        }}
                        disabled={(payload.reglements || []).length <= 1}
                      >
                        <FaTrash size={11} />
                      </button>
                    </div>
                  ))}
                </div>

                <hr className="bl_payment_divider" />

                {/* Remise */}
                <div>
                  <span className="bl_payment_subsection_label">{t("Remise")}</span>
                  <div className="bl_remise_row" style={{ marginTop: "8px" }}>
                    <input
                      className="bl_compact_input"
                      type="number"
                      value={payload.remise}
                      onChange={(e) => setPayload(prev => ({ ...prev, remise: e.target.value }))}
                      placeholder="0"
                      min="0"
                      max="100"
                      style={{ textAlign: "center" }}
                    />
                    <div className={`bl_remise_badge ${totals.total_remise > 0 ? '' : 'empty'}`}>
                      {totals.total_remise > 0 ? `-${totals.total_remise.toFixed(2)} ${t("MAD")}` : `— ${t("aucune remise")}`}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>{/* end bl_modal_body */}

        {/* ── Sticky Summary Footer ── */}
        <div className="bl_summary_footer">
          <div className="bl_summary_numbers">
            <div className="bl_summary_item">
              <div className="label">{t("Sous-total")}</div>
              <div className="value">{totals.total_amount.toFixed(2)} {t("MAD")}</div>
            </div>
            {totals.total_remise > 0 && (
              <div className="bl_summary_item remise">
                <div className="label">{t("Remise")} ({payload.remise}%)</div>
                <div className="value">-{totals.total_remise.toFixed(2)} {t("MAD")}</div>
              </div>
            )}
            {totals.total_returns > 0 && (
              <div className="bl_summary_item retours">
                <div className="label">{t("Retours")}</div>
                <div className="value">-{totals.total_returns.toFixed(2)} {t("MAD")}</div>
              </div>
            )}
            <div className="bl_summary_item net">
              <div className="label">{t("Net à payer")}</div>
              <div className="value">{totals.net_amount.toFixed(2)} {t("MAD")}</div>
            </div>
          </div>

          <button
            className="bl_submit_btn"
            onClick={handle_submit}
          >
            {isEditMode ? t("Modifier le Bon") : t("Créer le Bon de Livraison")}
          </button>
        </div>

      </Modal>

      <div
        className="flex flex-col total_contacts_sections gap shadow"
        style={{ margin: "0", maxWidth: "100%" }}
      >
        <div className="flex items-center">
          <b>{t("Résumé des livraison")}</b>
        </div>

        <div className="flex items-center w-full summary_kpis_container">
          <div className="flex items-center gap">
            <div className="document_icon_container flex justify-center items-center">
              <IoDocumentTextOutline className="doc_icon" />
            </div>
            <div className="flex flex-col">
              <h6 className="total less_black">
                {livraisons?.total || 0} {t("Bons")}
              </h6>
              <p className="total_money">
                {(livraisons?.livraisons?.reduce((acc, item) => acc + getDisplayAmount(item), 0) || 0).toLocaleString("en-US")} {t("MAD")}
              </p>
            </div>
          </div>

          <div className="flex gap to-right summary_kpis">
            {/* Count items by is_return field */}
            {(() => {
              // Count all items across all livraisons
              let livraisonCount = 0;
              let livraisonAmount = 0;
              let retourCount = 0;
              let retourAmount = 0;

              livraisons?.livraisons?.forEach(l => {
                if (l?.items && l.items.length > 0) {
                  l.items.forEach(item => {
                    const qty = item.quantity || 1;
                    const price = (item.quantity || 1) * (item.unit_price || 0);
                    if (item.is_return) {
                      retourCount += qty;
                      retourAmount += price;
                    } else {
                      livraisonCount += qty;
                      livraisonAmount += price;
                    }
                  });
                }
              });

              return (
                <>
                  <div className="flex flex-col kpi">
                    <h6 className="total less_black">{livraisonCount}</h6>
                    <p className="total_money">
                      {livraisonAmount.toLocaleString("en-US")} {t("MAD")}
                    </p>
                    <span
                      className="nugget_status"
                      style={{
                        backgroundColor: "#dcfce7",
                        color: "#16a34a",
                      }}
                    >
                      {t("Livraison")}
                    </span>
                  </div>
                  <div className="flex flex-col kpi">
                    <h6 className="total less_black">{retourCount}</h6>
                    <p className="total_money">
                      {retourAmount.toLocaleString("en-US")} {t("MAD")}
                    </p>
                    <span
                      className="nugget_status"
                      style={{
                        backgroundColor: "#fee2e2",
                        color: "#dc2626",
                      }}
                    >
                      {t("Retour")}
                    </span>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      </div>

      <div className="clients_overview latest_clients_overview shadow">
        <div className="chart_section_header flex items-center">
          <b>{t("Bons de Livraison")}</b>
          <div className="relative to-right flex gap">
            {bulkIds?.length > 0 && (
              <div
                className="flex gap items-center filter_button"
                onClick={() => setShowStatusUpdate(true)}
              >
                <AiOutlineEdit
                  style={{ color: "#7983ff", fontSize: "1.2rem" }}
                />
              </div>
            )}
            <div className="flex gap items-center">
              <DatePicker
                selected={selectedMonth.date}
                onChange={(date) =>
                  setSelectedMonth({
                    monthNum: date.getMonth() + 1,
                    date: date,
                  })
                }
                dateFormat="MMMM yyyy"
                showMonthYearPicker
                customInput={
                  <div className="flex gap items-center filter_button">
                    <MdDateRange
                      style={{ color: "#7983ff", fontSize: "1.2rem" }}
                    />
                  </div>
                }
              />
              {/* Commercial User Filter - Only visible for admin/employee, not for commercial role */}
              {userData?.role !== "commercial" && commercialUsers.length > 0 && (
                <div className="relative">
                  <DropDown
                    customButtonStyle="justify-start"
                    button={
                      <>
                        <b>
                          {searchPayload.employee_id
                            ? commercialUsers.find((u) => u._id === searchPayload.employee_id)?.full_name || t("Tous les commerciaux")
                            : t("Tous les commerciaux")}
                        </b>
                        <IoMdArrowDropdown />
                      </>
                    }
                  >
                    <div
                      className="drop_item"
                      onClick={() => setSearchPayload((prev) => ({ ...prev, employee_id: "" }))}
                    >
                      {t("Tous les commerciaux")}
                    </div>
                    {commercialUsers.map((user) => (
                      <div
                        key={user._id}
                        className="drop_item"
                        onClick={() => setSearchPayload((prev) => ({ ...prev, employee_id: user._id }))}
                      >
                        {user.full_name}
                      </div>
                    ))}
                  </DropDown>
                </div>
              )}
              <div
                className="flex gap items-center filter_button"
                onClick={() => setShowFullTable(!showFullTable)}
              >
                {showFullTable ? (
                  <RiArrowUpSLine
                    style={{ color: "#7983ff", fontSize: "1.2rem" }}
                  />
                ) : (
                  <RiArrowDownSLine
                    style={{ color: "#7983ff", fontSize: "1.2rem" }}
                  />
                )}
              </div>

              <div
                className="flex gap items-center filter_button"
                onClick={handle_open_add}
              >
                <IoIosAdd style={{ color: "#7983ff", fontSize: "1.4rem" }} />
                <b>{t("Nouveau BL")}</b>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap summary_clients_section">
          <div className="flex stock_head gap">
            <div className="flex gap total_div  ml_15 mt_-10">
              <p>{t("Total Bons")}</p>
              <b>{livraisons?.livraisons?.length || 0}</b>
            </div>
            <div className="flex gap total_div  ml_15 mt_-10">
              <p>{t("Total Value")}</p>
              <b>
                {livraisons?.livraisons?.reduce((acc, item) => acc + getDisplayAmount(item), 0) || 0} {t("MAD")}
              </b>
            </div>

            <div className="flex gap search_section">
              <Input
                placeholder="Search"
                setChange={(e) =>
                  setSearchPayload((prev) => ({ ...prev, query: e }))
                }
                value={searchPayload.query}
                customInputStyle="search_input_edited"
                customParentStyle="parent_search_input_edited"
              />
            </div>
          </div>

          <div
            className="table_section table_section_overwrite"
            style={{ height: showFullTable ? "auto" : "calc(100vh - 350px)" }}
          >
            <table cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  <td className="table-keys table_keys_overwrite cell2 checkbox_table_cell"></td>
                  <td className="table-keys cell2 pointer">{t("Réf")}</td>
                  <td
                    className="table-keys cell2 pointer"
                    onClick={() =>
                      setSearchPayload((prev) => ({
                        ...prev,
                        order_by: prev.order_by === "new" ? "old" : "new",
                      }))
                    }
                  >
                    {t("Date")}
                    {searchPayload?.order_by === "new" ? (
                      <IoIosArrowDown
                        style={{ marginBottom: "-2px", marginLeft: "8px" }}
                      />
                    ) : (
                      <IoIosArrowUp
                        style={{ marginBottom: "-2px", marginLeft: "8px" }}
                      />
                    )}
                  </td>
                  <td className="table-keys cell2 pointer">{t("Produits")}</td>
                  <td className="table-keys cell2 pointer">
                    {t("Destinataire")}
                  </td>
                  <td className="table-keys cell2 pointer">{t("Adresse")}</td>
                  <td className="table-keys cell2 pointer">{t("Tel")}</td>
                  <td className="table-keys cell2 pointer">{t("Montant")}</td>
                  <td className="table-keys cell2 pointer">{t("Règlements")}</td>
                  <td className="table-keys cell2 pointer">{t("Action")}</td>
                </tr>

                {livraisons?.livraisons?.length > 0 &&
                  livraisons?.livraisons?.map((elem, i) => (
                    <tr className={`data-cells`} key={elem?._id}>
                      <td className={`value2 cell2  checkbox_table_cell`}>
                        <input
                          type="checkbox"
                          checked={bulkIds.includes(elem?._id)}
                          onClick={() => handle_add_bulk(elem?._id)}
                        />
                      </td>
                      <td className={`value2 cell2`} style={{ fontSize: "11px", color: "#666" }}>
                        {htmlParser.parse(
                          containsQuery(searchPayload.query, elem?.reference || elem?._id?.slice(-6))
                        )}
                      </td>
                      <td className={`value2 cell2  `}>
                        {formatDate(elem?.created)}
                      </td>
                      <td className={`value2 cell2 rm_wrap`}>
                        {htmlParser.parse(
                          containsQuery(searchPayload.query, getProductDisplay(elem))
                        )}
                        {elem?.total_returns > 0 && (
                          <span style={{
                            marginLeft: "5px",
                            color: "#ef4444",
                            fontSize: "10px",
                            backgroundColor: "#fee2e2",
                            padding: "2px 4px",
                            borderRadius: "3px"
                          }}>
                            {t("retour")}
                          </span>
                        )}
                      </td>
                      <td className={`value2 cell2  `}>
                        {htmlParser.parse(
                          containsQuery(searchPayload.query, elem?.buyer),
                        )}
                      </td>
                      <td className={`value2 cell2 rm_wrap`}>
                        {htmlParser.parse(
                          containsQuery(searchPayload.query, elem?.adresse),
                        )}
                      </td>
                      <td className={`value2 cell2  `}>
                        {htmlParser.parse(
                          containsQuery(searchPayload.query, elem?.buyer_phone),
                        )}
                      </td>
                      <td className={`value2 cell2  `}>
                        <div className="flex flex-col">
                          <span style={{ fontWeight: "bold" }}>{getDisplayAmount(elem)} {t("MAD")}</span>
                          {elem?.total_returns > 0 && (
                            <span style={{ fontSize: "10px", color: "#ef4444" }}>
                              (-{elem.total_returns} {t("retours")})
                            </span>
                          )}
                        </div>
                      </td>
                      <td className={`value2 cell2`}>
                        {elem?.reglements?.length > 0 ? (
                          <div className="flex flex-col">
                            {elem.reglements.map((reg, idx) => (
                              <span key={idx} style={{ fontSize: "11px" }}>
                                {getReglementModeName(reg)}: {reg.amount} {t("MAD")}
                              </span>
                            ))}
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className={`value2 cell2 action`}>
                        <div className="flex gap_5 justify-center">
                          <HiQrcode
                            className="action_btn"
                            style={{ backgroundColor: "grey" }}
                            onClick={() => generateAndDownload(elem?._id)}
                          />
                          <AiOutlineEdit
                            className="action_btn edit"
                            onClick={() => handle_open_edit(elem)}
                          />
                          {userData?.role === "admin" && (
                            <MdDeleteOutline
                              className="action_btn delete"
                              onClick={() =>
                                handle_delete_livraison(elem?._id)
                              }
                            />
                          )}
                          <AiOutlinePrinter
                            className="action_btn"
                            style={{ backgroundColor: "#3b82f6" }}
                            title="Imprimer A4"
                            onClick={() => handleDownloadPdf(elem, "a4")}
                          />
                          <IoReceiptOutline
                            className="action_btn"
                            style={{ backgroundColor: "#8b5cf6" }}
                            title="Imprimer Ticket"
                            onClick={() => handleDownloadPdf(elem, "receipt")}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Print Preview Overlay */}
      {showPrintPreview && (
        <div className="preview_overlay_backdrop">
          <div className="print_preview_modal">
            <div className="print_preview_header">
              <div className="preview_actions">
                <button
                  className="preview_download_btn"
                  onClick={triggerPreviewDownload}
                >
                  <AiOutlinePrinter size={18} />
                  {t("Télécharger PDF")}
                </button>
                <button
                  className="preview_close_btn"
                  onClick={() => {
                    setShowPrintPreview(false);
                    if (previewBlobUrl) {
                      URL.revokeObjectURL(previewBlobUrl);
                      setPreviewBlobUrl(null);
                    }
                  }}
                >
                  {t("Fermer")}
                </button>
              </div>
            </div>
            <div className="print_preview_body">
              {previewBlobUrl && (
                <iframe
                  src={previewBlobUrl}
                  title="BL Preview"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Shipments;
